import { OnInit, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { FileUploader } from 'ng2-file-upload';
import { DocumentoService } from 'src/app/services/documento.service';
import { MatDialog } from '@angular/material/dialog';
import { GLOBAL } from 'src/app/services/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
var url = GLOBAL.url;
var uri = url + 'upload/file';
var ArchivosComponent = /** @class */ (function () {
    // public docNombre = new FormControl('', [Validators.required ]);
    function ArchivosComponent(_documentosServices, dialog, cd, spinner, toastr) {
        var _this = this;
        this._documentosServices = _documentosServices;
        this.dialog = dialog;
        this.cd = cd;
        this.spinner = spinner;
        this.toastr = toastr;
        this.panelOpenState = false;
        this.yasubieron = false;
        this.uploader = new FileUploader({ url: uri });
        this.attachmentList = [];
        this.hasBaseDropZoneOver = false;
        this.hasOnFileDrop = false;
        this.inputList = [];
        this.isReady = false;
        this.archivosSubidos = [];
        this.archivoSubidoFind = false;
        this.cantArSubidosObligatorios = 0;
        this.arrayArchivos = [];
        this.pdfUrl = GLOBAL.pdfUrl;
        this.acotado = GLOBAL.acotado;
        this.nombreMuni = GLOBAL.nombreMuni;
        this.docAccept = GLOBAL.docAccept;
        this.enableUpload = false;
        this.adjuntos = [];
        this.files = [];
        this.rows = [];
        this.documentoNombre = '';
        this.maxSizeFiles = 75000000;
        this.actualSizeFiles = 0;
        this.animate = false;
        this.disableNombre = false;
        this.inputdatos = [];
        this.storageDatos = [];
        this.fileNames = [];
        this.docNames = [];
        this.docRepetido = false;
        this.fileRepetido = false;
        this.nombreArchivo = '';
        if (this.acotado == true) {
            this.form = localStorage.getItem("formId");
        }
        else {
            this.form = JSON.parse(localStorage.getItem("form"));
        }
        this.demolicion_archivo = localStorage.getItem("archivo_demolicion");
        if (!JSON.parse(localStorage.getItem("adjuntos"))) {
            localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos));
        }
        else {
            this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
        }
        this.uploader.onAfterAddingFile = function (file) {
            file.withCredentials = false;
        };
        this.uploader.onCompleteItem = function (item, response, status, headers) {
            //console.log('onCompleteitem response:', response);
            ////console.log(response)
            _this.attachmentList.push(response);
        };
    }
    ArchivosComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getUploaders();
        if (this.acotado != true) {
            setTimeout(function () { return _this.dialog.open(_this.openModal); });
        }
    };
    ArchivosComponent.prototype.cerrarModal = function () {
        this.nombreArchivo = '';
        this.dialog.closeAll();
    };
    ArchivosComponent.prototype.fileOverBase = function (e) {
        this.hasBaseDropZoneOver = e;
    };
    ArchivosComponent.prototype.onFileDrop = function (e, archivo) {
        if (archivo === void 0) { archivo = null; }
        this.archivoSubidoFind = false;
        for (var i = 0; i < this.archivosForm.length; i++) {
            if (this.archivosForm[i].name == archivo.name) {
                this.archivosForm[i].ready = true;
            }
        }
        this.archivosSubidos.push(archivo);
        if (this.archivosSubidos) {
            if (this.arrayArchivos.length == 0) {
                this.arrayArchivos.push(archivo);
                ////console.log(this.arrayArchivos)
            }
            else {
                ////console.log("entre en arrayarchivos")
                ////console.log(this.arrayArchivos)
                for (var i = 0; i < this.arrayArchivos.length; i++) {
                    ////console.log(this.arrayArchivos[i])
                    ////console.log(archivo.name)
                    if (this.arrayArchivos[i].name == archivo.name) {
                        ////console.log("encontre el mismo nombre")
                        this.archivoSubidoFind = true;
                    }
                }
            }
        }
        if (!this.archivoSubidoFind) {
            this.arrayArchivos.push(archivo);
            if (archivo.obligatorio) {
                this.cantArSubidosObligatorios = this.cantArSubidosObligatorios + 1;
                ////console.log("this.cantArSubidosObligatorios: ", this.cantArSubidosObligatorios)
                ////console.log("Falta subir archivos");
            }
        }
        this.nombreForm = archivo.name;
        this.unir(archivo.name);
    };
    // onInsert() {
    //     var subidos = { "archivosSubidos": false };
    //     localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
    // }
    ArchivosComponent.prototype.marcarArchivos = function () {
        /*
        var contObligatorios = 0
        for (let i = 0; i < this.archivosForm.length; i++) {
            if (this.archivosForm[i].obligatorio) {
                contObligatorios = contObligatorios + 1
            }
            localStorage.setItem("archivos_obligatorios", JSON.stringify(contObligatorios));
        }
        if (this.cantArSubidosObligatorios >= contObligatorios) {
            */
        var subidos = { "archivosSubidos": true };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
        swal({
            type: 'success',
            title: 'Archivos cargados',
            text: '<p>ya puedes continuar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        }).then(function () {
            window.scrollTo(0, document.body.scrollHeight);
        });
        /*
    }
    else {
        var subidos = { "archivosSubidos": false };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
        swal({
            type: 'error',
            title: 'No has subido todos los archivos obligatorios ',
            text: '<p>adjuntalos y presiona el boton subir archivos para continuar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        })
    }*/
    };
    ArchivosComponent.prototype.fileInput = function (archivo) {
        //console.log(archivo)
    };
    ArchivosComponent.prototype.getUploaders = function () {
        var _this = this;
        var intervalStart = false;
        if (!intervalStart) {
            this.interval = setInterval(function () {
                if (localStorage.getItem("archivos2")) {
                    intervalStart = true;
                }
            }, 2000);
        }
        if (intervalStart) {
            this.archivosForm = localStorage.getItem("archivos2");
            ////console.log(this.archivosForm)
        }
        this._documentosServices.getUploaders().subscribe(function (response) {
            if (_this.acotado == true) {
                _this.form = localStorage.getItem("formId");
            }
            else {
                _this.form = localStorage.getItem("form");
            }
            if (_this.form == '5.8' && (_this.demolicion_archivo == false || _this.demolicion_archivo == "false")) {
                var contador = 0;
                for (var i = 0; i < response.documentos.length; i++) {
                    if (_this.form == response.documentos[i].name) {
                        while (contador < 6) {
                            ////console.log(contador);
                            _this.arrayArchivos.push(response.documentos[i].archivos[contador]);
                            contador++;
                        }
                        _this.archivosForm = _this.arrayArchivos;
                    }
                }
            }
            else {
                for (var i = 0; i < response.documentos.length; i++) {
                    if (_this.form == response.documentos[i].name) {
                        _this.archivosForm = response.documentos[i].archivos;
                    }
                }
            }
        }, function (error) {
            //console.log(error);
        });
    };
    ArchivosComponent.prototype.removeAll = function () {
        for (var i = 0; i < this.inputList.length; i++) {
            if (this.inputList[i].ready) {
                this.inputList[i].ready = false;
            }
        }
        this.inputdatos.splice(0);
        //localStorage.setItem("archivos", JSON.stringify([]));
    };
    ArchivosComponent.prototype.removeFile = function (nombre) {
        /*//console.log(nombre)
        //console.log(this.inputdatos)
        //console.log(this.inputList)*/
        var index;
        for (var i = 0; i < this.inputdatos.length; i++) {
            if (this.inputdatos[i].nombreArchivo == nombre) {
                for (var x = 0; x < this.inputList.length; x++) {
                    if (this.inputList[x].name == this.inputdatos[i].nombreForm) {
                        index = i;
                        this.inputList[x].ready = false;
                    }
                }
            }
        }
        this.inputdatos.splice(index, 1);
        //this.setStorage();
    };
    ArchivosComponent.prototype.unir = function (fileType) {
        if (fileType === void 0) { fileType = ''; }
        this.uploader.queue[this.uploader.queue.length - 1].file.name = fileType + '-' + new Date().getTime() + '-' + this.uploader.queue[this.uploader.queue.length - 1].file.name;
        this.nombreArchivo = this.uploader.queue[this.uploader.queue.length - 1].file.name;
        this.adjuntoActual = this.uploader.queue[this.uploader.queue.length - 1].file.name;
        ////console.log("nombre del form", this.nombreForm)
        this.inputdatos.push({
            'linkArchivo': this.pdfUrl + "/" + this.nombreArchivo,
            'nombreForm': this.nombreForm,
        });
        localStorage.removeItem("archivos");
        ////console.log(localStorage.getItem("archivos"))
        localStorage.setItem("archivos", JSON.stringify(this.inputdatos));
        ////console.log(localStorage.getItem("archivos"))
    };
    /*
        onFileAdd(ev: any, file){
    
            //si no tiene informacion...
    
    
            let actualAdjuntos = localStorage.getItem("adjuntos");
            this.adjuntos = JSON.parse(actualAdjuntos);
    
                this. adjuntos = this.adjuntos.concat({
                    nombre:
                })
    
                localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos));
                this.form.reset();
        }
        */
    ArchivosComponent.prototype.openAdjuntosModal = function () {
        this.dialog.open(this.modalAdjuntos, { disableClose: true });
    };
    ArchivosComponent.prototype.cancelarAdjunto = function () {
        var tmpName = this.uploader.queue[this.uploader.queue.length - 1].file.name;
        this.removeFile(tmpName);
        this.uploader.queue[this.uploader.queue.length - 1].remove();
        localStorage.removeItem("archivos");
        localStorage.setItem("archivos", JSON.stringify(this.inputdatos));
        this.enableUpload = false;
        this.nombreArchivo = '';
    };
    ArchivosComponent.prototype.deleteFile = function (index) {
        if (index === void 0) { index = null; }
        if (index != null) {
            //recalcular size
            var fil = void 0;
            fil = this.files[index].doc;
            this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0;
            //console.log("this.actualSizeFiles - fil.size", this.actualSizeFiles, fil.size);
            //Remove file
            //console.log("files", this.files, "index", index)
            this.files.splice(index, 1);
            var actualRow = localStorage.getItem("adjuntos");
            this.rows = JSON.parse(actualRow);
            this.rows.splice(index, 1);
            localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        }
        else {
            //recalcular size
            var fil = void 0;
            fil = this.files[this.files.length - 1].doc;
            this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0;
            //Remove file
            this.files.splice(this.files.length - 1, 1);
            var actualRow = localStorage.getItem("adjuntos");
            this.rows = JSON.parse(actualRow);
            this.rows.splice(this.rows.length - 1, 1);
            localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        }
    };
    ArchivosComponent.prototype.handleFileInput = function (files) {
        console.log("handleFileInput()");
        //console.log('before this.files ', this.files)
        //this.newFile: File //nuevo file
        this.newFile = files.item(0);
        this.newFiles = files;
        var actualRow = localStorage.getItem("adjuntos");
        //console.log('actualRow (  localStorage.getItem("adjuntos")  )', actualRow);
        this.rows = JSON.parse(actualRow);
        //this.nombreDeArchivo = "";//nombre despues agregar (1||+)
        //this.nombreDeDocumento = "";//nombre despues agregar (1||+)
        this.nombreArchivo = files.item(0).name;
        console.log("this.nombreArchivo", this.nombreArchivo);
        //validar extension
    };
    ArchivosComponent.prototype.validarSubida = function () {
        var _this = this;
        this.fileRepetido = false;
        this.docRepetido = false;
        this.nombreDeDocumento = this.documentoNombre; //documentoNombre = nombre ingresado en input
        var regexp = new RegExp(/^\s+$/);
        if (this.documentoNombre.match(regexp)) {
            this.documentoNombre = this.nombreArchivo;
            this.nombreDeDocumento = this.documentoNombre;
            console.log('espacio(s) en blanco o vacio, renombrado: ', this.documentoNombre);
            this.toastr.warning("El Nombre del Documento estaba en blanco, se renombr\u00F3: " + this.nombreDeDocumento + " ");
        }
        this.files.forEach(function (element) {
            if (element.name == _this.nombreDeDocumento) {
                _this.docRepetido = true;
            }
        });
        var filenameCounter = 0;
        this.nombreDeArchivo = this.nombreArchivo;
        this.files.forEach(function (element) {
            // //console.log('element', element)
            // //console.log('element.doc.archivo', element.doc.name)
            if (element.doc.name == _this.nombreArchivo) {
                _this.fileRepetido = true;
            }
        });
        console.log("this.fileRepetido", this.fileRepetido);
        console.log("this.docRepetido", this.docRepetido);
        if (!this.fileRepetido && !this.docRepetido) {
            this.adjuntoSave();
        }
        else {
            if (this.fileRepetido) {
                swal({
                    icon: 'error',
                    title: 'Archivo duplicado',
                    text: '<p>Usted ya adjunto un archivo con el mismo nombre</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    _this.cerrarModal();
                });
            }
            else if (this.docRepetido) {
                swal({
                    icon: 'error',
                    title: 'Nombre de documento duplicado',
                    text: '<p>Usted ya adjunto un documento con el mismo nombre</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    _this.cerrarModal();
                });
            }
        }
    };
    ArchivosComponent.prototype.adjuntoSave = function (fileName) {
        var _this = this;
        if (fileName === void 0) { fileName = null; }
        console.log("adjuntoSave this.files", this.files);
        console.log("adjuntoSave this.nombreDeDocumento.trim()", this.nombreDeDocumento.trim());
        var subidos = { "archivosSubidos": false };
        localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
        this.files.push({ name: this.nombreDeDocumento.trim(), doc: this.newFile });
        // this.files.forEach(element => {
        //     this.docNames.push(element.name.trim());
        //     this.fileNames.push(element.doc.name.trim());
        // });
        var peso = (this.newFiles.item(0).size / 1000000) + ' MB';
        this.rows = this.rows.concat({
            name: this.nombreDeDocumento.trim(),
            archivo: this.nombreDeArchivo.trim(),
            peso: peso,
            estado: "Pendiente"
        });
        localStorage.setItem("adjuntos", JSON.stringify(this.rows));
        this.actualSizeFiles = this.actualSizeFiles + this.newFiles.item(0).size;
        this.checksSize(this.files.length - 1);
        this.documentoNombre = '';
        this.cerrarModal();
        //animar
        this.animate = true;
        setTimeout(function () {
            _this.animate = !_this.animate;
        }, 1);
    };
    ArchivosComponent.prototype.checksSize = function (index) {
        //console.log("this.actualSizeFiles > this.maxSizeFiles", this.actualSizeFiles, this.maxSizeFiles);
        if (index === void 0) { index = null; }
        if (this.actualSizeFiles > this.maxSizeFiles) {
            this.deleteFile(index);
            this.alertMaxsize();
            this.cerrarModal();
        }
    };
    ArchivosComponent.prototype.alertMaxsize = function () {
        swal({
            icon: 'error',
            title: 'Supero el máximo de MB para tus adjuntos',
            text: '<p>Usted cuenta con un máximo de <strong>75 MB</strong> para utilizar</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
        });
    };
    ArchivosComponent.prototype.confirmarSubida = function () {
        this.dialog.open(this.confirmaSubida, { disableClose: true });
    };
    ArchivosComponent.prototype.uploadAllfiles = function () {
        var _this = this;
        console.log('subir archivos');
        var formType = (this.form) ? this.form : 'Acotado';
        this.spinner.show();
        if (this.nombreMuni == 'Penaflor') {
            console.log("Enviar Archivos penaflor");
            this._documentosServices.uploadFiles(this.files, formType).subscribe(function (response) {
                console.log('uploadFiles response', response);
                _this.spinner.hide();
                var subidos = { "archivosSubidos": true };
                _this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
                _this.adjuntos.forEach(function (element) {
                    element.estado = "Subido";
                });
                localStorage.setItem("adjuntos", JSON.stringify(_this.adjuntos));
                var actualRow = localStorage.getItem("adjuntos");
                _this.rows = JSON.parse(actualRow);
                console.log('JSON.parse(localStorage.getItem("adjuntos"))', JSON.parse(localStorage.getItem("adjuntos")));
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
                var alert = { icon: 'success', text: '', title: '' };
                if (response.code == 99) {
                    _this.cerrarModal();
                    console.log('yasubieron');
                    _this.yasubieron = true;
                    alert.icon = 'success';
                    alert.text = '<p>Se subieron los archivos correctamente<br><br></p>';
                    alert.title = 'Archivos cargados';
                    localStorage.setItem('ZipURL', response.url);
                }
                else if (response.code == 98) {
                    alert.icon = 'error';
                    alert.text = '<p>No se adjuntaron documentos</p>';
                    alert.title = 'Archivos no cargados';
                }
                else if (response.code == 97) {
                    alert.icon = 'error';
                    alert.text = '<p>No se adjuntaron documentos</p>';
                    alert.title = 'Archivos no cargados';
                }
                else if (response.code == 96) {
                    alert.icon = 'error';
                    alert.text = '<p>Archivos no permitidos</p>';
                    alert.title = 'Archivos no cargados';
                }
                else {
                    alert.icon = 'error';
                    alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>';
                    alert.title = 'Archivos no cargados';
                }
                swal({
                    icon: alert.icon,
                    title: alert.title,
                    text: alert.text,
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    window.scrollTo(0, document.body.scrollHeight);
                });
            }, function (error) {
                _this.spinner.hide();
                console.log("un error", error);
                _this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
                var subidos = { "archivosSubidos": false };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
                swal({
                    icon: 'error',
                    title: 'Error al subir documentación',
                    text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    window.scrollTo(0, document.body.scrollHeight);
                });
            });
        }
        else {
            this._documentosServices.uploadFilesDBX(this.files, formType).subscribe(function (response) {
                _this.spinner.hide();
                _this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
                _this.adjuntos.forEach(function (element) {
                    element.estado = "Subido";
                });
                localStorage.setItem("adjuntos", JSON.stringify(_this.adjuntos));
                var actualRow = localStorage.getItem("adjuntos");
                _this.rows = JSON.parse(actualRow);
                console.log('JSON.parse(localStorage.getItem("adjuntos"))', JSON.parse(localStorage.getItem("adjuntos")));
                var subidos = { "archivosSubidos": true };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
                var alert = { icon: 'success', text: '', title: '' };
                if (response.code == 99 && response.url) {
                    _this.cerrarModal();
                    console.log('yasubieron');
                    _this.yasubieron = true;
                    alert.icon = 'success';
                    alert.text = '<p>Puedes revisar una vez más tus documentos, usa el siguiente link <br><br> <a mat-stroked-button href="' + response.url + '" style="text-decoration=none" target="_blank"><strong>Descarga tus documentos<strong></a><br><br><br></p>';
                    alert.title = 'Archivos cargados';
                    localStorage.setItem('ZipURL', response.url);
                }
                else if (response.code == 98) {
                    alert.icon = 'error';
                    alert.text = '<p>No se adjuntaron documentos</p>';
                    alert.title = 'Archivos no cargados';
                }
                else if (response.code == 97) {
                    alert.icon = 'error';
                    alert.text = '<p>No se adjuntaron documentos</p>';
                    alert.title = 'Archivos no cargados';
                }
                else if (response.code == 96) {
                    alert.icon = 'error';
                    alert.text = '<p>Archivos no permitidos</p>';
                    alert.title = 'Archivos no cargados';
                }
                else {
                    alert.icon = 'error';
                    alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>';
                    alert.title = 'Archivos no cargados';
                }
                swal({
                    icon: alert.icon,
                    title: alert.title,
                    text: alert.text,
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    window.scrollTo(0, document.body.scrollHeight);
                });
            }, function (error) {
                _this.spinner.hide();
                console.log("un error", error);
                var subidos = { "archivosSubidos": false };
                localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
                swal({
                    icon: 'error',
                    title: 'Error al subir documentación',
                    text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false
                }).then(function () {
                    window.scrollTo(0, document.body.scrollHeight);
                });
            });
        }
    };
    return ArchivosComponent;
}());
export { ArchivosComponent };
